import axios from 'axios';

export const Graylog = axios.create({
  headers: {
    'Authorization': '',
    'Content-Type': 'application/json'
  }
})

Graylog.setBaseUrl = (url) => {
  Graylog.url = url
  Graylog.defaults.baseURL = `${url}/api/search/universal/`
}

Graylog.setApiToken = (apiToken) => {
  Graylog.defaults.headers["Authorization"] = 'Basic ' + btoa(`${apiToken}:token`)
}

Graylog.search = (searchQuery, params) => {
  params.query = searchQuery;
  return Graylog.get('relative', { params: params });
};

Graylog.getDeployments = (params) => {
  let facility = params.facility.replace('production', 'release')
  params.query = `facility:"${facility}" AND "[CI FINISHED]"`;

  return Graylog.get('relative', { params: params });
};

Graylog.getTerms = (searchQuery, params) => {
  params.query = searchQuery;
  return Graylog.get('relative/terms', { params: params });
};

Graylog.getStats = (field, searchQuery, params) => {
  params.field = field;
  params.query = searchQuery;
  return Graylog.get('relative/stats', { params: params });
};


Graylog.toTimeline = (object, field_or_callback) => {
  return Object.entries(object).map((time_and_data) => {
    let value;
    if (typeof field_or_callback == 'function') {
      value = field_or_callback(time_and_data[1]);
    } else {
      value = time_and_data[1][field_or_callback];
    }
    return [1*time_and_data[0], value];
  });
}

Graylog.getFieldHistogramm = (field, searchQuery, params) => {
  params.query = searchQuery;
  params.field = field;
  params.cardinality = false;

  return Graylog.get('relative/fieldhistogram', { params: params });
};